import { getIcon, IconProductType, IconType, SubtypeFor } from './types';

interface IconProps<T extends IconType> extends React.SVGProps<SVGSVGElement> {
  product: IconProductType;
  type: T;
  subtype?: SubtypeFor<T> | 'default';
}
export const GenericIcon = <T extends IconType>({
  product,
  type,
  subtype = 'default' as SubtypeFor<T>,

  ...props
}: IconProps<T>) => {
  const { icon: ProductIcon, size } = getIcon(product, type, subtype);

  if (!ProductIcon) {
    return null;
  }
  return (
    <ProductIcon width={size} height={size} size={size ?? 53} {...props} />
  );
};
